<template>
  <ArticleCard
    v-if="article"
    :key="article.title"
    :article="article"
    variant="vertical"
    :hide="['description', 'date']"
    size="full"
    class="mx-5 my-2.5 w-full"
  />
</template>
<script>
import { defineComponent, inject, watch, ref, onMounted } from '@nuxtjs/composition-api';
import ArticleCard from '@/modules/common/components/article/ArticleCard';
import { useDevice } from '@/composables/useDevice';
// Not Completed YET
export default defineComponent({
  components: {
    ArticleCard,
  },
  setup() {
    const adConfig = inject('adConfig');
    const { isMobile } = useDevice();
    const article = ref();
    onMounted(() => {
      if (adConfig.value.recommendedArticlesLoaded.value) {
        article.value = adConfig.value.getSponsoredArticle();
      } else {
        watch(adConfig.value.recommendedArticlesLoaded, () => {
          article.value = adConfig.value.getSponsoredArticle();
        });
      }
      watch(isMobile, () => {
        if (!article.value) {
          article.value = adConfig.value.getSponsoredArticle();
        }
      });
    });
    return { article };
  },
});
</script>
